import "./MaintenanceBanner.css";

import { Fragment, useEffect } from "react";

import { fetchMessages } from "shared/actions/messagesActions";

import { useAppDispatch, useAppSelector } from "app/hooks";
import { useSelectedLab } from "hooks/useSelectedLabStation";

import MaintenanceBanner from "./MaintenanceBanner";

const MaintenanceBannerController = ({
  isLogin = false,
}: {
  isLogin?: boolean;
}) => {
  const dispatch = useAppDispatch();
  const messages = useAppSelector((state) => state.sys.messages);

  const lab = !isLogin ? useSelectedLab() : null;

  useEffect(() => {
    dispatch(fetchMessages("pw-lis"));
  }, [lab?.id]);

  return messages?.length ? (
    <div className="MaintenanceBanner__container">
      {messages.map((message, idx) => {
        return (
          <Fragment key={idx}>
            <MaintenanceBanner m={message} />
          </Fragment>
        );
      })}
    </div>
  ) : null;
};

export default MaintenanceBannerController;
